<template>
  <a-card title="用户登录授权管理">
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input  style="width:100px" placeholder="User ID" v-model:value="formSearch.user_id" />
        </a-form-item>
         <a-form-item label="手机区号" >
          <a-input style="width:60px" placeholder="手机区号" v-model:value="formSearch.region_code" />
        </a-form-item>
        <a-form-item  label="登录凭证">
          <a-input placeholder="登录凭证" v-model:value="formSearch.open_id" />
          <p>*可直接输入手机号</p>
        </a-form-item>
        <a-form-item label="授权类型">
          <a-select
            style="width:80px;"
            v-model:value="formSearch.auth_type"
            :options="auth_types"
            placeholder="授权类型"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="() => handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
        <template #id="{ record }">
          <a :href="'http://admin.xuantu.pro/home/creation/works?user_id='+record.id">{{ record.id }}</a>
        </template>
        <template #nickname="{ record }">
          <span>{{ record.nickname ? record.nickname : '-' }}</span>
        </template>
        <template #first_task="{ record }">
         <div v-if="record.task_id > 0">
            <a :href="`/home/creation/works?task_id=` + record.task_id">{{ record.creation_kind }} {{ record.style_name }}</a>
          <div>{{ TaskStatus[record.task_status] }} ({{ record.reason }})</div>
         </div>
        </template>
        <template #auth="{ record }">
          <a-tooltip>
            <template #title>{{ record.auth.open_id }}</template>
            {{ record.auth.open_id ? "*******" + record.auth.open_id.substr(record.auth.open_id.length -4, 4) : '-' }}
          </a-tooltip>
        </template>
        <template #auth_type="{ record }">
          {{ record.auth.auth_type }}
        </template>
        <template #phone="{ record }">
          <a-tooltip>
            <template #title>{{ record.country_code + record.phone }}</template>
            {{ record.phone ? "*******" + record.phone.substr(record.phone.length -4, 4) : '-' }}
          </a-tooltip>
        </template>
        <template #is_vip="{ record }">
          <a-tag v-if="record.is_vip" color="red">VIP</a-tag>
        </template>
    
      </a-table>
  </a-card>

  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import axios from 'axios'
import { message } from 'ant-design-vue';
import request from '@/utils/request'
import { Modal } from 'ant-design-vue';
import { useStore } from 'vuex'
const TaskStatus = {
  0: "排队中",
  1: "创作中",
  2: "创作完成",
  3: "创作失败",
}

export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    return {
      TaskStatus,
      loading: false,
      dataSource: [],
      auth_types: [{
        label: "手机",
        value: "mobile"
      },{
        label: "邮箱",
        value: "email"
      },{
        label: "微信",
        value: "wechat"
      },{
        label: "Google",
        value: "google"
      },{
        label: "Apple",
        value: "apple"
      }],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',

       formSearch: {
        auth_type: '',
        region_code: '86',
        open_id:'',
        user_id: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.handleTableChange()
  },
  computed:{
    nickname : () => {
      const store = useStore()
      if (store) {
        return `${store.state.user.nickname}-${store.state.user.user_id}`
      }
      
    },
  },
  methods: {
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      let query = {
        ...this.formSearch
      }
      if (query.auth_type && query.auth_type != 'mobile') {
        query.region_code = ''
      }

      if (query.region_code && query.open_id) {
        query.open_id = `+${query.region_code}-${query.open_id}`
      }


      const rsp = await request.get('/api/users/auths/search', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...query
      })
      this.loading = false
      if (rsp.data.list) {
        this.dataSource = [].concat(rsp.data.list)
      } else {
        this.dataSource = []
      }
    
      this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      this.pagination.total = rsp.data.pagination.total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'UID',
          dataIndex: 'id',
          key: 'id',
          slots: { customRender: 'id' },
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          key: 'nickname',
          slots: { customRender: 'nickname' },
        },
        {
          title: '登录凭证',
          dataIndex: 'auth',
          key: 'auth',
          slots: { customRender: 'auth' },
        },
        {
          title: '授权类型',
          dataIndex: 'auth_type',
          key: 'auth_type',
          slots: { customRender: 'auth_type' },
        },
        // {
        //   title: '执行次数',
        //   dataIndex: 'creation_count',
        //   key: 'creation_count',
        // },
        // {
        //   title: '第一次任务',
        //   dataIndex: 'first_task',
        //   key: 'first_task',
        //   slots: { customRender: 'first_task' },
        // },
        {
          title: '会员',
          dataIndex: 'is_vip',
          key: 'is_vip',
          slots: { customRender: 'is_vip' },
        },
        {
          title: '会员过期时间',
          dataIndex: 'vip_expired_at',
          key: 'vip_expired_at',
          // slots: { customRender: 'is_vip' },
        },
        {
          title: '注册时间',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
</style>